import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlaneDeparture } from '@fortawesome/free-solid-svg-icons';
import { isOutOfOffice, outOfOfficeTooltip } from '../utils/outOfOffice.js';
import './OutOfOffice.css';

const OutOfOfficeMark = ({ outOfOffice }) => {
  if (!isOutOfOffice({ outOfOffice })) {
    return null;
  }

  return (
    <span className="out-of-office-mark" title={outOfOfficeTooltip(outOfOffice)}>
      <FontAwesomeIcon icon={faPlaneDeparture} />
    </span>
  );
};

export default OutOfOfficeMark;
